import React from "react";
import { ArrowLeftIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";
export function HarbourIsleEast() {
  return <main className="flex min-h-screen w-full flex-col bg-amber-950 text-amber-50" data-id="element-143" data-mp="319e6c9im5ywp">
      <section className="flex flex-1 items-center px-6 py-16 sm:px-10 lg:px-14" data-id="element-144" data-mp="367xsa9x7jap2">
        <div className="mx-auto w-full max-w-3xl" data-id="element-145" data-mp="369sgbx3rzixd">
          <Link to="/harbour-isle-properties" className="inline-flex items-center gap-2 text-sm font-bold text-amber-100 transition-[color] duration-200 hover:text-white" data-id="element-146" data-mp="2ri0aqcts9j8u">
            <ArrowLeftIcon size={17} aria-hidden="true" data-id="element-147" data-mp="2ijobjmeupd4s" />
            Back to Harbour Isle Properties
          </Link>
          <p className="mt-16 text-xs font-bold uppercase tracking-[0.18em] text-amber-300" data-id="element-148" data-mp="2mk89utb5umsi">Harbour Isle · Fort Pierce</p>
          <h1 className="mt-5 font-display text-5xl leading-[0.92] sm:text-7xl" data-id="element-149" data-mp="28mjozlh3ffng">Harbour Isle East.</h1>
          <p className="mt-7 max-w-xl text-lg leading-8 text-amber-100" data-id="element-150" data-mp="2dl4spuvk0hgn">
            Available properties, rentals, and community information for Harbour Isle East are coming soon.
          </p>
        </div>
      </section>
      <SiteFooter tone="warm" data-id="element-151" data-mp="1qxjqx69wr7ju" />
    </main>;
}